<template>
    <div class="wrapper">
        <div class="page-header page-header-small">
            <parallax class="page-header-image" style="background-image: url('img/cisterna_s_privesem.jpg')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h4>Komplexní služby v oblasti odpadového hospodářství.</h4>
                        <h1 class="title">OD ROKU 1995</h1>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="section">
            <div class="about-description text-center">
                <div class="features-3">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 mr-auto ml-auto">
                                <h2 class="title">O nás</h2>
                                <h5 class="description">Společnost  MINOREC k.s. vznikla v roce 1995 z iniciativy mateřské firmy <a href="https://www.oel-schmidt.de/Standorte/standorte.php" target="_blank">Mineralölhandel Hans Schmidt GmbH & Co. KG</a>, která  působí  ve Fürthu v Bavorsku již více než šest desetiletí a zabývá se odstraňováním odpadních olejů.
                                </h5>
                                <h5 class="description">Odpadní oleje sbíráme od roku 1995 a při své činnosti využíváme cenných zkušeností mateřské firmy. Orientujeme se na odstranění odpadních olejů z automobilového, strojírenského a kovozpracujícího průmyslu.
                                </h5>
                                <h5 class="description">Z počátku bylo odstranění odpadních olejů hlavním a jediným cílem firmy, později vznikla potřeba, zejména pro drobné a střední podniky, nabídnout komplexní služby v oblasti odpadového hospodářství od poradenské činnosti přes analýzy až po <a href="/#/odpady">odstranění dalších odpadů</a>.  
                                </h5>
                                <h5 class="description">Ke sběru odpadních olejů používáme speciálně upravené vícekomorové autocisterny, jejichž cisternové nástavby byly vyrobeny v mateřské firmě a jsou vybaveny řadou unikátních technických prvků zajišťujících vysokou bezpečnost při manipulaci s odpadními oleji. Díky takto upraveným vozidlům je možné nabídnout odstranění olejů, emulzí či zaolejovaných vod zároveň.
                                </h5>
                                <h5 class="description">Oleje třídíme dle kvality již při čerpání olejů do autocisteren u zákazníků. Sebrané oleje analyzujeme, a ty které splňují analyzované ukazatele, vyvážíme na základě notifikace k recyklaci do rafinerií v SRN, neboť v ČR není žádné zařízení umožňující materiálové využití odpadních olejů. Postupujeme tak v souladu s ustanovením zákona č. 541/2020 Sb., který upřednostňuje materiálové využití odpadů před spalováním. Naši činnost vykonáváme na základě integrovaného povolení <a href="/img/ruk_ippc.pdf" target="_blank">(IPPC)</a>  a v souladu s politikou <a href="/img/ISO_9001.pdf" target="_blank">ISO 9001</a> a <a href="/img/ISO_14001.pdf" target="_blank">ISO 14 001</a>.
                                </h5>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="separator-line separator-primary"></div>

        </div>
    </div>
</template>
<script>
  import { Card, Button, Badge, InfoSection, FormGroupInput, Checkbox } from '@/components';
  import { Select, Option } from 'element-ui'

  export default {
    name: 'about-us',
    bodyClass: 'about-us',
    components: {
      Card,
      InfoSection,
      Badge,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        form: {
          name: '',
          email: '',
          phone: ''
        }
      }
    }
  }
</script>
<style>
.section {
    padding: 0 0 !important;
}

.about-us {
    padding: 0 0 !important;
}
.about-description, .about-contact {
    padding: 0 0 !important;
}        
.features-3 {
    padding: 20px 0 !important;
}        
.description {
    color: #888 !important;
    font-weight: 500 !important;
}    

.page-header {
    min-height: 80vh !important;
}  

</style>
